import { render, staticRenderFns } from "./AdminSlots.vue?vue&type=template&id=a0a129c0&"
import script from "./AdminSlots.vue?vue&type=script&lang=js&"
export * from "./AdminSlots.vue?vue&type=script&lang=js&"
import style0 from "./AdminSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports